import { render, staticRenderFns } from "./OptimizeTruck.vue?vue&type=template&id=bfa06968&scoped=true"
import script from "./OptimizeTruck.vue?vue&type=script&lang=ts"
export * from "./OptimizeTruck.vue?vue&type=script&lang=ts"
import style0 from "./OptimizeTruck.vue?vue&type=style&index=0&id=bfa06968&prod&lang=scss&scoped=true"
import style1 from "./OptimizeTruck.vue?vue&type=style&index=1&id=bfa06968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa06968",
  null
  
)

export default component.exports